export const DEFAULT_LANGUAGE = 'en-US';
export const DEFAULT_NAV_BACKGROUND_COLOR = 'transparent';
export const DEFAULT_NAV_FOREGROUND_COLOR = 'black';
